import { Controller, useFormContext } from 'react-hook-form';
import { Button, ButtonGroup, FormMessage } from '@readcloud/ui';
import cn from 'classnames';
import { contentTypeConfig } from './schemas/uploadWizardConfig';
import {
  Book,
  FileText,
  Globe,
  Music,
  Video,
  Image,
  Upload,
  Check,
  Cloud,
  ListCollapse,
} from 'lucide-react';
import { ContentFieldData } from './schemas/formFields';
import { useStepper } from '../Stepper/Stepper';

export const iconMapping = {
  book: <Book className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
  fileText: <FileText className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
  globe: <Globe className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
  music: <Music className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
  video: <Video className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
  image: <Image className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
  upload: <Upload className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
  check: <Check className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
  cloud: <Cloud className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
  listCollapse: <ListCollapse className='max-sm:rc-h-4 max-sm:rc-w-4'/>,
} as const;

export const SelectContentType = () => {
  const {
    control,
    formState: { errors },
    trigger,
  } = useFormContext<ContentFieldData>();

  const { nextStep } = useStepper();

  return (
    <Controller
      control={control}
      name={'content.type'}
      render={({ field }) => (
        <div className="rc-flex rc-flex-col rc-gap-2">
          <ButtonGroup className="rc-flex rc-flex-col [&>*:first-child]:rc-rounded-l-none [&>*:last-child]:rc-rounded-r-none [&>*:first-child]:rc-rounded-t-md [&>*:last-child]:rc-rounded-b-md">
            {Object.entries(contentTypeConfig).map(([key, value]) => (
              <Button
                data-testid={`upload-type-${key}`}
                variant="ghost"
                className="rc-justify-start rc-text-start rc-rounded-none rc-h-auto rc-px-3 rc-gap-2 rc-py-[0.75rem] sm:rc-py-4 rc-w-full "
                onClick={async () => {
                  field.onChange(key);
                  const valid = await trigger('content.type');
                  if (valid) {
                    nextStep();
                  }
                }}
                key={key}
                value={key}
              >
                <span
                  className={cn(
                    value.selectContentType.color,
                    'rc-rounded-full rc-p-2'
                  )}
                >
                  {iconMapping[value.selectContentType.icon]}
                </span>

                <span>{value.selectContentType.label}</span>
              </Button>
            ))}
          </ButtonGroup>
          {errors['content.type'] && (
            <FormMessage>{errors['content.type'].message}</FormMessage>
          )}
        </div>
      )}
    />
  );
};
